import * as React from 'react'
import { KeyboardTypeOptions, Platform, Text, TextInput, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import useBreakpoints from '@utils/useBreakpoints'

import theme from '@theme/Theme'

interface Props {
  disabled?: boolean
  error?: string
  hint?: string
  keyboardType?: KeyboardTypeOptions
  onChange: (value: string) => void
  placeholder?: string
  value?: string
  onSubmit: () => void
}

const TextInputComponent = ({
  disabled = false,
  error,
  hint,
  keyboardType,
  onChange,
  onSubmit,
  placeholder,
  value,
}: Props) => {
  const [, currentBreakpoint] = useBreakpoints()
  const isPhone = currentBreakpoint === 'phone'

  return (
    <View>
      <RowContainer>
        <InputContainer disabled={disabled}>
          <FieldContainer>
            <CustomTextInput
              editable={!disabled}
              keyboardType={keyboardType}
              onChangeText={onChange}
              onSubmitEditing={onSubmit}
              placeholder={placeholder}
              placeholderTextColor={theme.colors.secondaryText}
              value={value}
            />
          </FieldContainer>
        </InputContainer>
        <SubmitButton activeOpacity={0.9} onPress={onSubmit}>
          <Icon name="arrow" size={24} color={theme.colors.background} />
        </SubmitButton>
      </RowContainer>

      {(!!error || (isPhone && !!hint)) && <Hint error={!!error}>{error || hint}</Hint>}
    </View>
  )
}

export default TextInputComponent

const InputContainer = styled(View)<{ disabled: boolean }>`
  ${(props) => !props.disabled && `background-color: ${props.theme.colors.background};`}
  min-height: ${(props) => (props.theme.breakpoint === 'phone' ? 48 : 56)}px;
  flex-direction: row;
  align-items: center;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  padding: 14px 16px;
  flex: 1;
`
const RowContainer = styled(View)`
  flex-direction: row;
`
const FieldContainer = styled(View)`
  flex: 1;
`
const SubmitButton = styled(TouchableOpacity)`
  width: ${(props) => (props.theme.breakpoint === 'phone' ? 48 : 56)}px;
  background-color: ${(props) => props.theme.colors.primary};
  align-items: center;
  justify-content: center;
`
const CustomTextInput = styled(TextInput)<{ editable: boolean }>`
  ${(props) => props.theme.fonts.Body};
  ${(props) =>
    Platform.OS === 'web' &&
    `
    outline-width: 0px;
    outline-style: none;
    caret-color: ${props.theme.colors.primary};`}
  padding: 0;
  color: ${(props) =>
    props.theme.breakpoint === 'phone'
      ? props.theme.colors.primaryText
      : props.editable
      ? props.theme.colors.primaryText
      : props.theme.colors.disableDark};
`
const Hint = styled(Text)<{ error: boolean }>`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => (props.error ? props.theme.colors.negate : props.theme.colors.secondaryText)};
  margin-top: 8px;
`
